
import { useEffect } from 'react'
import Select from 'react-select'
import { STPTankMasterDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const STPTankNoDataDDL = (props) => {
    const { TankNo, setTankNo, WardName,IsPost } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_WardID: WardName.ID,
            M_UserID: UserID,
            token: token,
            // M_STP_UnitTypeID: UnitType.ID,
        }
        // if (UnitType.ID) {
        dispatch(STPTankMasterDDLAPI({ data }))
        // }
    }, [IsPost,WardName.ID])

    const { STPTankMasterData } = useSelector(state => state.STPTankMasterDDL)

    useEffect(() => {
        handleSTPTankMasterDDL()
    }, [STPTankMasterData])

    const handleSTPTankMasterDDL = () => {
        // console.log(DeptDDLDataa)
        if (STPTankMasterData && STPTankMasterData.table && STPTankMasterData.table.length > 0) {
            let list = STPTankMasterData.table.map((item, index) => ({
                value: item.m_stP_TankMasterID,
                label: item.tankNo,
            }))

            // setEmployeeDDL({
            //     DDL: list,
            //     ID: Flag === 'Update' ? rowData.m_EmployeeID : 0,
            //     Label: Flag === 'Update' ? rowData.employeeName : "Select...",
            // })
            setTankNo({ ...TankNo, DDL: list })
        }
        else {
            setTankNo({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }
    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Tank No </b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: TankNo.ID, label: TankNo.Label }}
                onChange={(e) => {
                    e ?
                        setTankNo({ ...TankNo, ID: e.value, Label: e.label })
                        :
                        setTankNo({ ...TankNo, ID: 0, Label: "Select..." })

                }}
                options={TankNo.DDL}
            />
        </div>
    )
}